module.exports = __webpack_public_path__ + "static/media/mysti-jack-wink 1.af9dba30.png";